// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { SxProps } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Link } from 'react-router';
import type { Theme } from '../../theme/Theme';
import { Box } from '../base';

export function LinkUnderline({
  children,
  isActive,
  to,
  sx,
}: {
  readonly children: React.ReactNode;
  readonly isActive?: boolean;
  readonly to: string;
  readonly sx?: SxProps<Theme>;
}) {
  return (
    <Box
      component={Link}
      to={to}
      sx={{
        border: 'none',
        display: 'inline-block',
        textDecoration: 'none',
        color: 'primary.contrastText',
        '&::after': {
          borderBottom: '1px solid white',
          content: '""',
          display: 'block',
          transform: isActive === true ? 'scaleX(1)' : 'scaleX(0)',
          transition: 'transform 0.2s ease-in-out',
        },
        '&:hover::after': {
          transform: 'scaleX(1)',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
